import React from 'react';
import { ChevronDown, type LucideIcon } from 'lucide-react';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@dashboard/components/ui/collapsible';

interface Props {
  /** Lucide icon rendered to the left of the label. */
  icon: LucideIcon;
  label: string;
  /** Optional pill rendered next to the label (e.g. "11 available"). */
  badge?: React.ReactNode;
  defaultOpen?: boolean;
  /** Externally-controlled open state. Required when consumers need to
   *  collapse the disclosure on a downstream event (e.g. "Add selected"
   *  closes the past-events table after submission). */
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  children: React.ReactNode;
}

const SectionDisclosure: React.FC<Props> = ({
  icon: Icon,
  label,
  badge,
  defaultOpen,
  open,
  onOpenChange,
  children,
}) => (
  <Collapsible
    defaultOpen={defaultOpen}
    open={open}
    onOpenChange={onOpenChange}
    className="group/disclosure"
  >
    {/* Plain CollapsibleTrigger (renders a native button) — using the
        ui Button here would inherit its aria-expanded:bg-muted ghost
        style and paint the trigger when the disclosure is open. */}
    <CollapsibleTrigger className="w-full flex items-center justify-between py-3 px-1 text-sm font-medium hover:text-foreground transition-colors">
      <span className="inline-flex items-center gap-2">
        <Icon className="size-3.5 text-muted-foreground" />
        {label}
        {badge}
      </span>
      <ChevronDown className="size-3.5 text-muted-foreground transition-transform group-data-[state=open]/disclosure:rotate-180" />
    </CollapsibleTrigger>
    <CollapsibleContent className="pl-6 pr-1 pb-4 space-y-3">{children}</CollapsibleContent>
  </Collapsible>
);

export default SectionDisclosure;
